import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "movies-overview-area" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "movies-overview-inner",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImage})` })
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "movies-overview-content" }, [
          _createElementVNode("h2", { class: "text-white" }, "ابدأ تجربتك المجانية اليوم واكتشف الفرق بنفسك"),
          _createElementVNode("a", {
            href: "https://wa.me/447429916178",
            target: "_blank",
            class: "btn"
          }, [
            _createElementVNode("span", { class: "border-style" }, "اشترك الآن")
          ])
        ], -1)
      ]))], 4)
    ])
  ]))
}